import { errorNameOf } from "@pandas/logger";
import { createStaleChunkRecovery } from "@pandas/stale-chunk";
import { DEPLOY } from "@/config/deploy";
// The app logger, not the bare default: importing it configures Axiom before the boot-time replay logs.
import logger from "@/utils/logging/logger";

/**
 * The app's one stale-deploy recovery instance. The event name is the same in every app: product-v2 carries it
 * in the `event` field, product-v1 in both `event` and the message. The v1 apps share one Axiom dataset per
 * environment (`pandas-stg` / `-uat` / `-prod`), told apart by `project`; v2 logs to `pandas-v2-stg` / `-uat` /
 * `-prod`. Both match
 * `where ['event'] == "app.lazy_chunk_load_failed"`.
 */
export const staleChunkRecovery = createStaleChunkRecovery({
	// The unique deployment id re-arms the fuse on a same-commit redeploy; the SHA is only the fallback.
	deploymentId: () => DEPLOY.deploymentId || DEPLOY.sha,
	onChunkFailure: ({ error, chunkName, reason, reloadSpent, deferred, failedDeploymentId, recoveryId }) => {
		// An object message ships its fields top-level, so `event` is queryable; a trailing arg lands in metadata[0].
		logger.error("NETWORK", {
			event: "app.lazy_chunk_load_failed",
			message: "app.lazy_chunk_load_failed",
			chunkName,
			errorName: errorNameOf(error),
			reloadSpent,
			reason,
			deferred,
			failedDeploymentId: failedDeploymentId ?? "",
			recoveryId: recoveryId ?? "",
			deploySha: DEPLOY.sha,
		});
	},
	flush: () => logger.flushLogs(2000),
});
